import ExperienceSearchCategoryResults from 'components/Experiences/ExperiencesSearch/ExperienceSearchBar/ExperienceSearchCategoryResults'
import React, { useId } from 'react'
import SearchFloatingPanel from './SearchFloatingPanel'
import noop from 'lib/function/noop'

interface Props {
  open?: boolean
  onClose?: () => void
}

function ExperienceCategoryPanel(props: Props) {
  const { open, onClose = noop } = props
  const formId = useId()

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onClose()
  }

  return (
    <SearchFloatingPanel
      isOpen={open}
      onClose={onClose}
      onGoBack={onClose}
      onConfirm={onClose}
      title="What are you interested in?"
      confirmText="Apply"
    >
      <form onSubmit={onSubmit} id={formId}>
        <ExperienceSearchCategoryResults />
      </form>
    </SearchFloatingPanel>
  )
}

export default ExperienceCategoryPanel
